.stacked {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--tuna-spacing-0_5);
}

.row {
  display: flex;
  align-items: center;
  flex: none;
}

/* aria-disabled keeps focus and hover, so the disabled look is drawn here */
.inert {
  opacity: 0.6;
  cursor: default;
}

.caption {
  margin: 0;
  color: var(--tuna-content-secondary);
}

/* No :empty { display: none }: a live region that is display:none when its text arrives is not announced by
 * VoiceOver/NVDA. An empty <p> with no margin takes no height. */

/* Announced, not shown: the embed card swaps its own text instead (spec §8.9 #3) */
.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}
